import { createFileRoute } from '@tanstack/react-router';

import { HelpCategoriesPage, helpCategoriesQueryOptions } from '@/features/help-center';

export const Route = createFileRoute('/_authed/_active/s/$storeId/help/categories')({
  staticData: { crumb: 'common:nav.helpCategories' },
  loader: ({ context, params }) =>
    context.queryClient
      .query({ ...helpCategoriesQueryOptions(params.storeId), staleTime: 'static' })
      .catch(() => undefined),
  component: HelpCategoriesPage,
});
